import { render, staticRenderFns } from "./BindsButtonContent.vue?vue&type=template&id=5d2f3bca&"
import script from "./BindsButtonContent.vue?vue&type=script&lang=js&"
export * from "./BindsButtonContent.vue?vue&type=script&lang=js&"
import style0 from "./BindsButtonContent.vue?vue&type=style&index=0&id=5d2f3bca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports